<template>
    <div class="container-fluid">
        <format-list :formats="getFormats" actions></format-list>
    </div>
</template>

<script>
import FormatList from '@/components/FormatList';
import {mapGetters, mapActions} from 'vuex'
export default {
    name: "EntityFormats",
    components: {FormatList},
    created(){this.fetchEntityFormats()},
    methods: mapActions(['fetchEntityFormats']),
    computed: mapGetters(['getFormats'])
}
</script>

<style>

</style>